import http from '../utils/http.js';

export async function getVerificationCode() {
  return http.get('api/factor/getCode');
}

export async function validateCode(params) {
  const { factorCode } = params;
  return http.get('api/factor/validateCode'.concat(`?factorCode=${factorCode}`));
}




// WEBPACK FOOTER //
// ./src/services/verification.js